import CloseIcon from '@mui/icons-material/Close';
import { observer } from "mobx-react-lite";
import { useDetailsStore, useMapShapeStore, useMapStore, usePopupStore } from '..';
import useIsHalfScreenMap from '../hooks/useIsHalfScreenMap';
import DetailsType from '../interfaces/DetailsType';
import PopupType from '../interfaces/PopupType';
import commonStyles from './Common.module.css';
import MapShapeLayer from './MapShapeLayer';

function MapShapesLayer() {
    const mapStore = useMapStore();
    const mapShapeStore = useMapShapeStore();
    const popupStore = usePopupStore();
    const detailsStore = useDetailsStore();
    const isHalfScreenMap = useIsHalfScreenMap();

    if (!mapStore.isStyleLoaded) return null;

    const isShowHidePanel =
        popupStore.type !== PopupType.Property && detailsStore.type !== DetailsType.PropertyDetails &&
        popupStore.type !== PopupType.TenantInMarket && detailsStore.type !== DetailsType.TenantInMarketDetails &&
        (mapShapeStore.popupShapes.length || mapShapeStore.detailsShapes.length);

    return (
        <>
            {isShowHidePanel && (
                <div className={isHalfScreenMap ? commonStyles.halfWidthOnMapPanel : commonStyles.onMapPanel}>
                    Hide Shapes
                    <CloseIcon
                        className={commonStyles.clickableIcon}
                        onClick={() => mapShapeStore.clear()}
                    />
                </div>
            )}

            <MapShapeLayer id="popup" shapes={mapShapeStore.popupShapes} color="#f48e29" />
            <MapShapeLayer id="details" shapes={mapShapeStore.detailsShapes} color="#8283C1" />
        </>
    );
}

export default observer(MapShapesLayer);